import { render } from "./DietStays.vue?vue&type=template&id=5990d2ce"
import script from "./DietStays.vue?vue&type=script&lang=js"
export * from "./DietStays.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__